const filterByLocation = (jobs, location) => {
  if (!location) {
    return jobs
  }

  const filteredJobs = jobs.filter((job) => job.location.city === location)

  return filteredJobs
}

export { filterByLocation }
